module.exports = __webpack_public_path__ + "media/images/home/upload-d0a1a0ff234e083c669da66da88030ae.svg";